import { useSyncExternalStore } from "react";
import { persistFlagOverrideFromUrl } from "./flag-override";

export function createSyncClientFlag({
    param,
    key,
    env,
}: {
    param: string;

    key: string;

    env: boolean;
}) {
    persistFlagOverrideFromUrl(param, key);

    const read = (): boolean => {
        if (typeof window === "undefined") return env;
        try {
            const url = new URLSearchParams(window.location.search).get(param);
            if (url === "1") return true;
            if (url === "0") return false;
            const stored = window.localStorage.getItem(key);
            if (stored === "1") return true;
            if (stored === "0") return false;
        } catch {}
        return env;
    };
    function useFlag(): boolean {
        return useSyncExternalStore(
            (listener) => {
                persistFlagOverrideFromUrl(param, key);
                window.addEventListener("storage", listener);
                return () => window.removeEventListener("storage", listener);
            },
            read,
            () => env,
        );
    }
    return Object.assign(useFlag, { read });
}
